<script>
  import Heading from './Heading'
  import Header from '@/mixins/heading'

  export default {
    name: 'LandTitle',
    extends: Heading,
    mixins: [Header],

    props: {
      size: {
        type: String,
        default: 'text-h6',
      },
      mobileSize: {
        type: String,
        default: 'text-subtitle-2 text-md-subtitle-1',
      },
      tag: {
        type: String,
        default: 'h3',
      },
      weight: {
        type: String,
        default: 'bold',
      },
    },
  }
</script>
